import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import Card from 'primevue/card';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DetailRecordsList',
    props: {
        title: {
            type: String,
            required: true,
        },
        records: {
            type: Array,
            required: true,
        }
    },
    emits: ['add', 'showAll'],
    setup(__props, { expose, emit }) {
        expose();
        const __returned__ = { emit, get Button() { return Button; }, get Card() { return Card; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
